import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrManager } from 'ng6-toastr-notifications';
import { Unity } from 'src/app/models/unity';
import { AuthService } from 'src/app/services/auth.service';
import { UnityService } from 'src/app/services/unity.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from "src/environments/environment";

@Component({
  selector: 'app-unity-contrator',
  templateUrl: './unity-contrator.component.html',
  styleUrls: ['./unity-contrator.component.css']
})
export class UnityContratorComponent implements OnInit {

  loading:boolean = false;

  actEditUni: any;
  actDeleteUni: any;

  unities:Unity[] = [];
  unitiesTemp:Unity[] = [];
  unity:Unity = new Unity();
  img:string = '';

  //Pagination
  public page:number = 1;
  public pagination:number = 10;

  //Searching
  public find:string = '';

  constructor(private unityServ:UnityService, private authService:AuthService, private utl:UtilitiesService, private modalService:NgbModal, private toastr:ToastrManager) { }

  ngOnInit() {
    this.loading = true;
    this.img = environment.baseUrl + '/unities';
    this.actEditUni = this.authService.can("update-unity");
    this.actDeleteUni = this.authService.can("destroy-unity");

    this.unityServ.getUnities().then(unities => {
      this.unities = unities.filter(uni=>uni.unit_type.name == 'Contratistas');
      this.filter();
      this.loading = false;
    });
  }

  filter(){
    this.utl.search(this.unities, ['id', 'brand'], this.find, 'id', unities => this.unitiesTemp = unities);
  }

  confirmDelete(modal, unity:Unity){
    this.unity = unity;
    this.modalService.open(modal, { size: 'lg'});
  }

  delete(){
    this.loading = true;
    this.unityServ.deleteUnity(this.unity).then(resp => {
      this.modalService.dismissAll();
      this.unities.map(uni => { return (uni.id != this.unity.id)? this.unity : uni; });
      this.toastr.successToastr("Eliminado correctamente.");
      this.unity = new Unity();
      this.loading = false;
    },error => {
      this.toastr.errorToastr(error);
      this.loading = false;
    });
  }

}
